(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/constants.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/constants.js');
'use strict';

const routes = {
  HOME: '/',
  DEPOSIT_LIMITS: '/insattningsgranser',
  KYC: '/kundkannedom',
  KYC_RESUME: '/komplettera-kundkannedom',
  DEPOSIT: '/insattning',
  REJECTED: '/kan-inte-bli-kund',
  ACCOUNT_CREATED: '/konto-skapat',
  ANIMATION: '/animation'
};
svs.playerRegistration.constants = {
  routes
};

 })(window);